import { P2TextLabel } from 'react-bootstrap-common-script';
import { Separator } from '../../../../components/separator';
import useViewportWidth from '../../../../components/stepper/useViewportWidth';
import { Helpers } from '../../../../utils/helper';

interface CpfInstalmentPlanProps {
  cpfWithdrawalDetails: any;
}

function CpfInstalmentPlan({ cpfWithdrawalDetails }: CpfInstalmentPlanProps) {
  const isDesktopView = useViewportWidth();
  const { instalment } = cpfWithdrawalDetails || {};

  return (
    <div className='cpf-container' style={{ gap: '16px' }}>
      <div>
        <P2TextLabel
          bold={700}
          label={'Use of CPF Savings for Monthly Installments '}
          fontSize={isDesktopView ? '24px' : '20px'}
          lineHeight={isDesktopView ? '28px' : '22px'}
        />
      </div>
      <div className='polymer-stage-e_cpf-details'>
        <div className='polymer-stage-e_cpf-details_entry'>
          <div style={{ flex: '3' }}>
            <P2TextLabel label={'Monthly CPF deduction with effect from'} bold={'700'} />
          </div>
          {instalment && (
            <div className='d-flex flex-column flex-sm-row' style={{ flex: '2', textAlign: 'right' }}>
              <P2TextLabel label={Helpers.formatDate(instalment.date)} bold={'400'} />
              <P2TextLabel label={`$${Helpers.formatThousandSeparator(instalment.amount_paid_by_cpf)}`} bold={'400'} />
            </div>
          )}
        </div>
        <Separator />
        <div className='polymer-stage-e_cpf-details_entry'>
          <div style={{ flex: '3' }}>
            <P2TextLabel label={'Over a period of'} bold={'700'} />
          </div>
          {instalment && (
            <div className='d-flex' style={{ flex: '2', textAlign: 'right' }}>
              <P2TextLabel label={`${instalment.period} years`} bold={'400'} />
              {isDesktopView && <div></div>}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default CpfInstalmentPlan;
